import { render } from "./view-packaging-list.vue?vue&type=template&id=e8f52612&scoped=true"
import script from "./view-packaging-list.vue?vue&type=script&lang=js"
export * from "./view-packaging-list.vue?vue&type=script&lang=js"

import "./view-packaging-list.vue?vue&type=style&index=0&id=e8f52612&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f52612"]])

export default __exports__